import { captureStack1fzi4aczwc4hg as captureStack } from '../../js/coreRuntime.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlin_coroutines_cancellation_CancellationException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.$throwableCtor_4);
}
var CancellationExceptionClass;
function CancellationException() {
  if (CancellationExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      static new_kotlin_coroutines_cancellation_CancellationException_w2gt05_k$() {
        var $this = this.new_kotlin_IllegalStateException_1wtnp1_k$();
        init_kotlin_coroutines_cancellation_CancellationException($this);
        return $this;
      }
      static new_kotlin_coroutines_cancellation_CancellationException_kxgi4u_k$(message) {
        var $this = this.new_kotlin_IllegalStateException_w47ei6_k$(message);
        init_kotlin_coroutines_cancellation_CancellationException($this);
        return $this;
      }
      static new_kotlin_coroutines_cancellation_CancellationException_cpsifs_k$(message, cause) {
        var $this = this.new_kotlin_IllegalStateException_z3fz2g_k$(message, cause);
        init_kotlin_coroutines_cancellation_CancellationException($this);
        return $this;
      }
    }
    initMetadataForClass($, 'CancellationException', $.new_kotlin_coroutines_cancellation_CancellationException_w2gt05_k$);
    CancellationExceptionClass = $;
  }
  return CancellationExceptionClass;
}
//region block: exports
export {
  CancellationException as CancellationException3b36o9qz53rgr,
};
//endregion

//# sourceMappingURL=CancellationException.mjs.map
